import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ClientService } from 'src/app/services/archive/client.service';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { RentalReportService } from 'src/app/services/rental/rental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-balances-client-costcenter',
  templateUrl: './balances-client-costcenter.component.html',
  styleUrls: ['./balances-client-costcenter.component.scss'],
  standalone: false
})
export class BalancesClientCostcenterComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredStores: any[] = [];
  formRentalReportFilter: FormGroup = new FormGroup({});
  listArticle: any[] = [];
  listBranch: any[] = [];
  listClient: any[] = [];
  listConstructionSite: any[] = [];
  listCostCenter: any[] = [];
  listInventory: any[] = [];
  listReportType: CustomListDropdown[] = [{ label: 'Peso(Consolidado)', value: 1 }, { label: 'Peso(Por Bodega)', value: 2 },
  { label: 'Costo Promedio(Consolidado)', value: 3 }, { label: 'Costo Promedio(Por Bodega)', value: 4 },
  { label: 'Saldo Valorizado(Consolidado)', value: 5 }];
  listStore: any[] = [];
  nameWindow: string = 'Informe de Saldos por Cliente-Obra-C.Costos';
  projectName = ProjectName.projectName;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private clientService: ClientService,
    private constructionSiteService: ConstructionSiteService,
    private costCenterService: CostCenterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private rentalPeriodService: RentalPeriodService,
    private rentalReportService: RentalReportService,
    private storeService: StoreService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getFirstBranchByUserAuthenticatedAsync();
    await this.getAllLists();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formRentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  async changeClient(clientId: number) {
    this.formRentalReportFilter.controls["constructionSiteId"].patchValue(0);
    this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    this.changeFilter();
    if (clientId && clientId !== 0) {
      this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(clientId));
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(clientId, 0));
    } else {
      this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0));
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
      this.formRentalReportFilter.controls["clientId"].patchValue(0);
    }
  }

  async changeConstructionSite(constructionSiteId: number) {
    this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    this.changeFilter();
    if (constructionSiteId && constructionSiteId !== 0) {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, constructionSiteId));
    } else {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
      this.formRentalReportFilter.controls["constructionSiteId"].patchValue(0);
    }
  }

  changeCostCenter(costCenterId: number | null) {
    if (costCenterId === 0 || costCenterId === null || costCenterId === undefined) {
      this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeInventory(inventoryId: number | null) {
    this.filterStoreByInventoryId(inventoryId);
    if (inventoryId != 0 && inventoryId != null) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    } else {
      this.formRentalReportFilter.controls["inventoryId"].patchValue(0);
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeReportType(reportType: number) {
    if (reportType !== 2 && reportType !== 4) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
      this.formRentalReportFilter.controls["inventoryId"].patchValue(0);
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId', 'inventoryId'], false));
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId', 'inventoryId'], true));
    }
    this.changeFilter();
  }

  changeStore(storeId: number | null) {
    if (storeId === 0 || storeId === null || storeId === undefined) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  async clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0));
    this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
    this.changeReportType(this.formRentalReportFilter.controls["typeReport"].value);
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formRentalReportFilter.controls['dateInitial'].value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;
      const typeReportValue = this.formRentalReportFilter.get("typeReport")?.value;
      if (typeReportValue === 3) {
        modelRentalReportFilter.byStores = false;
      }
      let reportSuffix = '';
      switch (typeReportValue) {
        case 1:
          reportSuffix = 'Peso(Consolidado)';
          break;
        case 2:
          reportSuffix = 'Peso(Por Bodega)';
          break;
        case 3:
          reportSuffix = 'Costo Promedio(Consolidado)';
          break;
        case 4:
          reportSuffix = 'Costo Promedio(Por Bodega)';
          break;
        case 5:
          reportSuffix = 'Saldo Valorizado(Consolidado)';
          break;
        default:
          reportSuffix = 'General';
          break;
      }
      const baseTitle = modelRentalReportFilter.groups
        ? 'Informe de Saldos por Cliente-Obra-C.Costos por Grupo'
        : 'Informe de Saldos por Cliente-Obra-C.Costos';
      const fileName = `${baseTitle} - ${reportSuffix}.xlsx`;

      try {
        const response = await firstValueFrom(this.rentalReportService.exportRentalReportBalancesClientCostCenter(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterStoreByInventoryId(inventoryId: number | null) {
    const rowsFiltered = this.listStore.filter(x => x.inventoryId === inventoryId);
    if (inventoryId != null) {
      this.filteredStores = rowsFiltered;
    } else {
      this.filteredStores = this.listStore;
    }
    this.formRentalReportFilter.controls["storeId"].patchValue(0);
  }

  async getAllLists() {
    try {
      const [articles, branches, clients, constructionSites, costCenters, inventories, stores] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.clientService.getAllClientsForSelectAsync()),
        firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0)),
        firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0)),
        firstValueFrom(this.inventoryService.getAllInventoriesForSelectReportAsync()),
        firstValueFrom(this.storeService.getAllStoresForSelectAsync())
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listClient = clients;
      this.listConstructionSite = constructionSites;
      this.listCostCenter = costCenters;
      this.listInventory = inventories;
      this.listStore = stores;
      this.filteredStores = this.listStore;
      this.changeReportType(this.formRentalReportFilter.controls["typeReport"].value);
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formRentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filteredStores = this.listStore;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formRentalReportFilter.controls["dateInitial"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formRentalReportFilter.controls).forEach(key => {
      const control = this.formRentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRentalReportFilter.valid) {
      const dateInitial = this.formRentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;
      if (this.formRentalReportFilter.get("typeReport")?.value === 1 || this.formRentalReportFilter.get("typeReport")?.value === 3 ||
        this.formRentalReportFilter.get("typeReport")?.value === 5) {
        modelRentalReportFilter.byStores = false;
      } else {
        modelRentalReportFilter.byStores = true;
      }

      try {
        this.dataReport = await firstValueFrom(this.rentalReportService.rentalReportBalancesClientCostcenter(modelRentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeReport: {
        required: 'El campo Tipo Informe es obligatorio.',
        min: 'Debe seleccionar un Tipo Informe válido.'
      },
      dateInitial: {
        required: 'El campo Período es obligatorio.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      clientId: {
        notNumber: 'Debe seleccionar un Cliente válido.'
      },
      constructionSiteId: {
        notNumber: 'Debe seleccionar una Obra válida.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un Centro de Costos válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formRentalReportFilter = this.formBuilder.group({
      typeReport: [1, [Validators.required]],
      dateInitial: ['', [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      clientId: [0, [CustomValidators.numberOnlyValidator()]],
      constructionSiteId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      inventoryId: [0],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      groups: [false],
      articleName: [""]
    });
  }

}
